export default __webpack_public_path__ + "static/mcf-logo-02ed880067c4daf49672cc7663656ca4.png";